import { appDataName } from "../../app/dataTypes";
import { RootState } from "../../app/rootReducer";
import { controlPointSliceName } from "./dataTypes";
import { controlPointAdapter } from "./controlPointAdapter";

const selectSliceState = (state: RootState) => state[appDataName][controlPointSliceName];

const adapterSelectors = controlPointAdapter.getSelectors(selectSliceState);

export const selectErrorMessage = (state: RootState) => selectSliceState(state).errorMessage;

export const selectRequestState = (state: RootState) => selectSliceState(state).requestState;

export const selectCount = (state: RootState) => selectSliceState(state).count;

export const selectControlPointEntities = adapterSelectors.selectEntities;
export const selectControlPoints = adapterSelectors.selectAll;
export const selectControlPoint =
  (id = "") =>
  (state: RootState) =>
    adapterSelectors.selectById(state, id);
